const ed = [

    {label:"Occurance:",
    controlType:"radio button",
    options:["Always", "Intermittently"]
    },

    {label:"Nocturnal erections:",
    controlType:"radio button",
    options:["Yes", "No"]
    },
    
    {label:"Duration:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    },

    {label:"Any other information:",
    controlType:"text area",
    options:[]
    },

]

export default ed